<template>
  <b-modal 
    :visible="show" 
    title="Excluir da Blacklist"
    @hide="$emit('close')"
    hide-footer
    centered
  >
    <div>

      <b-form-group label="CPF/CNPJ">
        <b-form-input
          v-model="form.document"
          placeholder="Digite o CPF ou CNPJ "
          v-mask="mask"
        />
      </b-form-group>

      <b-form-group label="Motivo da exclusão">
        <b-form-select
          v-model="form.reasonType"
          :options="reasonOptions"
        />
      </b-form-group>
      <div v-if="form.reasonType === 'outro'">
        <b-form-input
          class="mb-1"
          v-model="form.reason"
          placeholder="Digite o motivo"
        />
      </div>
      <b-button 
        variant="danger" 
        block
        @click="confirmDelete"
      >
        Confirmar Exclusão
      </b-button>

    </div>
  </b-modal>
</template>

<script>
import { BModal, BFormGroup, BFormInput, BButton,BFormSelect } from 'bootstrap-vue'

export default {
  props: {
    show: Boolean
  },

  components: {
    BModal,
    BFormGroup,
    BFormInput,
    BButton,
    BFormSelect
  },

  data() {
  return {
    form: {
      document: '',
      reason: '',
      reasonType: null
    },
    reasonOptions: [
      { value: null, text: 'Selecione um motivo' },
      { value: 'erro', text: 'Inativação por erro' },
      { value: 'outro', text: 'Outro' }
    ]
  }
},
computed: {
  mask() {
    const numbers = this.form.document.replace(/\D/g, '')

    if (numbers.length <= 11) {
      return '###.###.###-##'
    }

    return '##.###.###/####-##' 
  }
},
  methods: {
   confirmDelete() {
    if (!this.form.document) {
      this.$toast.warning('Informe o documento')
      return
    }

    if (!this.form.reasonType) {
      this.$toast.warning('Selecione o motivo')
      return
    }

    if (this.form.reasonType === 'outro' && !this.form.reason) {
      this.$toast.warning('Informe o motivo')
      return
    }

    this.$bvModal
    .msgBoxConfirm('Tem certeza que deseja excluir este item da blacklist?', {
      title: 'Confirmação',
      size: 'sm',
      centered: true,
      okVariant: 'primary',
      okTitle: 'Sim, excluir',
      cancelTitle: 'Cancelar',
      cancelVariant: 'outline-secondary'
    })
    .then(value => {
      if (value) {
        const payload = {
          document: this.form.document,
          reason: this.form.reasonType === 'erro'
            ? 'Inativação por erro'
            : this.form.reason
        }

        this.$emit('submit', payload)
        this.reset()
      }
    })
}}}
</script>